<template>
  <div class="create-com-size">
    <div class="breadcrumb" style="background: #fff">{{ $route.query.type === 'edit' ? '编辑机器码' : $route.query.type === 'add' ? '新建机器码' : '查看机器码' }}</div>
    <div class="order-detail-basic">
      <el-form label-width="130px" :model="machineCodeVO" hide-required-asterisk :rules="rules" ref="addform">
        <el-form-item label="机器码名称:" prop="machineCodeName">
          <el-input placeholder="" v-model="machineCodeVO.machineCodeName" maxlength="20" v-if="$route.query.type !== 'check'" clearable></el-input>
          <span v-else>{{ machineCodeVO.machineCodeName }}</span>
        </el-form-item>
        <el-form-item label="机器码编号:" prop="machineCodeNumber">
          <el-input placeholder="" v-model.number="machineCodeVO.machineCodeNumber" v-if="$route.query.type !== 'check'" clearable></el-input>
          <span v-else>{{ machineCodeVO.machineCodeNumber }}</span>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="$router.go(-1)" v-if="$route.query.type === 'check'">确定</el-button>
      <el-button round type="primary" @click="save" v-else>保存</el-button>
    </div>
  </div>
</template>
<script>
import { machineCodeAdd, codeDetail, machineCodeUsable, machineCodeUpdate } from '@/api/pms'
export default {
  name: 'create-com-size',
  data () {
    var machineCodeNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('机器码编号不能为空'))
      } else if (/[^\d]/g.test(value) || (value + '').length !== 6) {
        callback(new Error('请输入六位数字'))
      } else {
        callback()
      }
    }
    return {
      machineCodeVO: {
        machineCodeName: '',
        machineCodeNumber: ''
      },
      rules: {
        machineCodeName: [
          { required: true, message: '请输入机器码名称', trigger: 'blur' }
        ],
        machineCodeNumber: [
          { validator: machineCodeNumber, trigger: 'blur' }
          // { required: true, message: '机器码编号不能为空', trigger: 'blur' },
          // { type: 'number', min: 5, max: 7, message: '请输入六位数字', trigger: 'blur' }
          // { min: 6, max: 6, message: '请输入六位数', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$route.query.type !== 'add') {
      this.getCodeDetail()
    }
  },
  methods: {
    getCodeDetail () {
      codeDetail(this.$route.query.id)
        .then(res => {
          if (res.data.success) {
            this.machineCodeVO = res.data.data
          }
        })
    },
    save () {
      this.$refs.addform.validate(success => {
        if (!success) {
          return
        }
        machineCodeUsable({
          act: this.$route.query.type === 'add' ? 0 : 1,
          machineCodeName: this.machineCodeVO.machineCodeName,
          machineCodeId: this.machineCodeVO.machineCodeId
        })
          .then(res => {
            if (!res.data.success) {
              return
            }
            if (this.$route.query.type === 'add') {
              machineCodeAdd(this.machineCodeVO)
                .then(res => {
                  if (res.data.success) {
                    this.$message.success('创建机器码成功')
                    this.$router.go(-1)
                  }
                })
            } else if (this.$route.query.type === 'edit') {
              machineCodeUpdate({
                id: this.$route.query.id,
                machineCodeVO: this.machineCodeVO
              })
                .then(res => {
                  if (res.data.success) {
                    this.$message.success('修改成功')
                    this.$router.go(-1)
                  }
                })
            }
          })
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.create-com-size {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: auto;

      @{deep} .el-input__inner {
        width: 65px;
      }
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }
}
</style>
